enum VRHeaderButtonType {
  BACK = "BACK",
  CLOSE = "CLOSE",
}

export default VRHeaderButtonType;
